import { LoanInvestmentSettings } from "../types";
import { generateAmortizationSchedule } from "../utils";

export const generateChartData = (
    loanInvestmentSettings: LoanInvestmentSettings,
    currentYear: number
) => {
    const { loanTerm, propertyPrice, valueImpact } = loanInvestmentSettings;
    const amortizationSchedule = generateAmortizationSchedule(
        loanInvestmentSettings
    );

    // Pre-calculate common values
    const totalYears = loanTerm + 1;
    const effectAmount = propertyPrice * (valueImpact / 100);

    // Generate years array once
    const years = Array.from({ length: totalYears }, (_, yearIndex) =>
        (currentYear + yearIndex).toString()
    );

    // Use a single map operation for all data arrays
    const data = years.map((_, yearIndex) => {
        const monthIndex = Math.min(
            yearIndex * 12,
            amortizationSchedule.length - 1
        );
        const schedulePoint = amortizationSchedule[monthIndex];

        return {
            propertyLoan: schedulePoint.mainPrincipal,
            improvementLoan: schedulePoint.capexPrincipal,
            propertyValue:
                propertyPrice + effectAmount * (yearIndex / loanTerm),
        };
    });

    return {
        years,
        propertyLoanData: data.map((d) => d.propertyLoan),
        improvementLoanData: data.map((d) => d.improvementLoan),
        equityData: data.map(
            (d) => propertyPrice - d.propertyLoan - d.improvementLoan
        ),
        propertyValueData: data.map((d) => d.propertyValue),
    };
};
